"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
/**
 *
 */
class SecurityApi extends runtime.BaseAPI {
    /**
     * Send the body as the form post body, the signature as a header with key \'Signature\' and, optionally, the tenant as a header with key \'Tenant\'
     */
    apiSecurityVerifyJsonWebSignaturePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.signature === null || requestParameters.signature === undefined) {
                throw new runtime.RequiredError('signature', 'Required parameter requestParameters.signature was null or undefined when calling apiSecurityVerifyJsonWebSignaturePost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.signature !== undefined && requestParameters.signature !== null) {
                headerParameters['Signature'] = String(requestParameters.signature);
            }
            if (requestParameters.tenant !== undefined && requestParameters.tenant !== null) {
                headerParameters['Tenant'] = String(requestParameters.tenant);
            }
            const response = yield this.request({
                path: `/api/Security/VerifyJsonWebSignature`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.TextApiResponse(response);
        });
    }
    /**
     * Send the body as the form post body, the signature as a header with key \'Signature\' and, optionally, the tenant as a header with key \'Tenant\'
     */
    apiSecurityVerifyJsonWebSignaturePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiSecurityVerifyJsonWebSignaturePostRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.SecurityApi = SecurityApi;
